import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dt__listPage-description", this.textHeight > 60 ? 'dt__listPage-description-max' : ''])
  }, [
    _createElementVNode("div", {
      ref: "descriptionText",
      innerHTML: this.editorConvertHTML
    }, null, 8 /* PROPS */, _hoisted_1),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.onViewText && $options.onViewText(...args))),
      class: "dt__listPage-description-moreButton"
    }, [
      _createTextVNode(_toDisplayString(this.viewText ? 'Скрыть всё' : 'Прочитать всё') + " ", 1 /* TEXT */),
      _createElementVNode("div", {
        class: _normalizeClass(["dt-arrowText", $data.viewText ? 'dt-arrowText-open' : ''])
      }, null, 2 /* CLASS */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, $data.textHeight > 60]
    ])
  ], 2 /* CLASS */))
}